export default {
  users: {
    list: [],
    total: 0
  },
}
